import { ChangeDetectorRef, Component, input, Input, OnDestroy, OnInit, output } from '@angular/core';
import { GoldIds, GOLDS } from '@soposopo/sopo-models/dist/shop/Golds';
import { ShopAnimationPartToPlay } from 'src/app/shared/services/purchase-animation/purchase-animation.service';
import { FeatureService } from 'src/app/core/firebase/feature.service';
import { SopoPopupService } from 'src/app/sopo-popup/service/sopo-popup.service';
import { ISelectedGoldProduct, ProductType } from '../../pages/shop-home/shop-home.page';
import { CoinflowService } from 'src/app/shared/services/coinflow/coinflow.service';
import { Subject, filter, takeUntil } from 'rxjs';

// Format price with decimals only when needed (e.g., $5 vs $4.99)
function formatPrice(amount: number): string {
    return amount % 1 === 0 ? `$${amount}` : `$${amount.toFixed(2)}`;
}

@Component({
    selector: 'shop-product',
    templateUrl: './product.component.html',
    styleUrls: ['./product.component.scss'],
    standalone: false
})
export class ShopProductComponent implements OnInit, OnDestroy {
    @Input() product: typeof GOLDS[GoldIds];
    @Input() productId: GoldIds;
    @Input() animation: boolean;
    @Input() playAnimation: ShopAnimationPartToPlay = 'all';
    buyViaPopup = input<boolean>(false);
    productSelected = output<{ product: ISelectedGoldProduct, productType: ProductType }>();

    public processing = false;
    public price: string;

    private destroy$ = new Subject<void>();
    isSweepBuckOn = true;

    imageUrl = {
        'gold_1k': '/assets/icon/chips/gold_chip.webp',
        'gold_5k': '/assets/icon/chips/sweepsbucks_gold1.webp',
        'gold_11k': '/assets/icon/chips/sweepsbucks_gold1.webp',
        'gold_23k': '/assets/icon/chips/sweepsbucks_gold2.webp',
        'gold_60k': '/assets/icon/chips/sweepsbucks_gold2.webp',
        'gold_130k': '/assets/icon/chips/sweepsbucks_gold3.webp',
    }

    constructor(
        private ref: ChangeDetectorRef,
        private featureService: FeatureService,
        private sopoPopupService: SopoPopupService,
        private coinflowService: CoinflowService,
    ) { }

    ngOnInit(): void {
        this.isSweepBuckOn = this.featureService.sweepbucks;

        this.coinflowService.sopoShopProductPrice$.pipe(
            filter(prices => !!prices),
            takeUntil(this.destroy$),
        ).subscribe(prices => {
            if (prices[this.productId]) {
                this.price = formatPrice(prices[this.productId]);
                this.ref.detectChanges();
            }
        });
    }

    goldIds(numberImage: number): boolean {
        if (!this.animation) return false;
        if ((this.productId === 'gold_1k' || this.productId === 'gold_5k' || this.productId === 'gold_11k') && numberImage === 1) return true;
        if ((this.productId === 'gold_23k' || this.productId === 'gold_60k') && numberImage === 2) return true;
        if (this.productId === 'gold_130k' && numberImage === 3) return true;
        return false;
    }

    sweepsbuckIds(numberImage: number): boolean {
        if (!this.animation) return false;
        if (this.productId === 'gold_5k' && numberImage === 1) return true;
        if ((this.productId === 'gold_11k' || this.productId === 'gold_23k' || this.productId === 'gold_60k') && numberImage === 2) return true;
        if (this.productId === 'gold_130k' && numberImage === 3) return true;
        return false;
    }

    async buy() {
        if (this.processing) return;

        this.productSelected.emit({ product: {productId: this.productId, product: this.product, price: this.price}, productType: 'gold'});

        if (!this.buyViaPopup()) return;

        this.sopoPopupService.coinflowInShop('app', {
            data: {
                productId: this.productId,
                product: this.product,
                playAnimation: this.playAnimation,
                price: this.price,
            },
            closeButton: true,
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
